import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { CelebrationPersona, EnrichedCelebration } from './celebration.types';

type Props = {
  item: EnrichedCelebration;
  persona: CelebrationPersona;
  className?: string;
};

export function CelebrationNextStep({ item, persona, className = '' }: Props) {
  if (!item.nextMilestoneTitle) return null;

  const ring = persona === 'seller' ? 'ring-purple-100' : 'ring-fuchsia-100';
  const link = persona === 'seller' ? 'text-purple-700 hover:text-purple-900' : 'text-fuchsia-700 hover:text-fuchsia-900';

  return (
    <div
      className={`rounded-xl border border-slate-100 bg-slate-50/80 px-3.5 py-3 ring-1 ring-inset ${ring} ${className}`}
      data-testid="celebration-next-milestone"
    >
      <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">Up next</p>
      <p className="mt-0.5 text-sm font-semibold text-slate-900">{item.nextMilestoneTitle}</p>
      {item.nextMilestoneHint ? (
        <p className="mt-0.5 text-xs leading-relaxed text-slate-500">{item.nextMilestoneHint}</p>
      ) : null}
      {item.nextMilestoneHref ? (
        <Link
          to={item.nextMilestoneHref}
          className={`mt-2 inline-flex items-center gap-0.5 text-xs font-semibold ${link}`}
        >
          View details
          <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden />
        </Link>
      ) : null}
    </div>
  );
}
